export const priceData = [
  {
    ndc: '27241011205',
    drugName: 'TADALAFIL TAB 5MG',
    quantity: 90,
    displayName: 'Tadalafil',
    drugLink: '/prescription/tadalafil',
    displayScript: '90 tablets, 5mg',
    displayPrice: 1026
  },
  {
    ndc: '60505082901',
    drugName: 'FLUTICASONE SPR 50MCG',
    quantity: 16,
    displayName: 'Fluticasone',
    drugLink: '/prescription/fluticasone-propionate',
    displayScript: '1 bottle, 16gm of 50mcg/act',
    displayPrice: 43
  },
  {
    ndc: '55111064410',
    drugName: 'OMEPRAZOLE CAP 20MG',
    quantity: 90,
    displayName: 'Omeprazole',
    drugLink: '/prescription/omeprazole',
    displayScript: '90 delayed release capsules, 20mg',
    displayPrice: 113
  },
  {
    ndc: '68180098103',
    drugName: 'LISINOPRIL TAB 20MG',
    quantity: 90,
    displayName: 'Lisinopril',
    drugLink: '/prescription/lisinopril',
    displayScript: '90 tablets, 20mg',
    displayPrice: 41
  },
  {
    ndc: '70700016201',
    drugName: 'PROGESTERONE CAP 100MG',
    quantity: 90,
    displayName: 'Progesterone',
    drugLink: '/prescription/progesterone',
    displayScript: '90 capsules, 100mg',
    displayPrice: 414
  },
  {
    ndc: '69097012715',
    drugName: 'AMLODIPINE TAB 5MG',
    quantity: 90,
    displayName: 'Amlodipine',
    drugLink: '/prescription/amlodipine-besylate',
    displayScript: '90 tablets, 5mg',
    displayPrice: 120
  },
  {
    ndc: '31722071310',
    drugName: 'PANTOPRAZOLE TAB 40MG',
    quantity: 90,
    displayName: 'Pantoprazole',
    drugLink: '/prescription/pantoprazole-sodium',
    displayScript: '90 delayed release tablets, 40mg',
    displayPrice: 219
  },
  {
    ndc: '33342004307',
    drugName: 'SILDENAFIL TAB 100MG',
    quantity: 30,
    displayName: 'Sildenafil',
    drugLink: '/prescription/sildenafil-citrate',
    displayScript: '30 tablets, 100mg',
    displayPrice: 1337
  },
  {
    ndc: '16571086350',
    drugName: 'BUPROPION TAB 300MG XL',
    quantity: 90,
    displayName: 'Bupropion XL',
    drugLink: '/prescription/bupropion-hcl-er-xl',
    displayScript: '90 tablet, 300mg',
    displayPrice: 211
  },
  {
    ndc: '00169477212',
    drugName: 'OZEMPIC INJ 8MG/3ML',
    quantity: 3,
    displayName: 'Ozempic',
    drugLink: '/prescription/ozempic',
    displayScript: '3 multidose pen, 3ml prefilled 8mg/3ml pen (2mg/dose)',
    displayPrice: 1241
  },
  {
    ndc: '13668013610',
    drugName: 'ESCITALOPRAM TAB 10MG',
    quantity: 90,
    displayName: 'Escitalopram',
    drugLink: '/prescription/escitalopram-oxalate',
    displayScript: '90 tablet, 10mg',
    displayPrice: 166
  },
  {
    ndc: '68382013210',
    drugName: 'TAMSULOSIN CAP 0.4MG',
    quantity: 90,
    displayName: 'Tamsulosin',
    drugLink: '/prescription/tamsulosin-hcl',
    displayScript: '90 capsule, 0.4mg',
    displayPrice: 207
  },
  {
    ndc: '68180035202',
    drugName: 'SERTRALINE TAB 50MG',
    quantity: 90,
    displayName: 'Sertraline',
    drugLink: '/prescription/sertraline-hcl',
    displayScript: '90 tablet, 50mg',
    displayPrice: 98
  },
  {
    ndc: '72205002299',
    drugName: 'ATORVASTATIN TAB 10MG',
    quantity: 90,
    displayName: 'Atorvastatin',
    drugLink: '/prescription/atorvastatin-calcium',
    displayScript: '90 tablet, 10mg',
    displayPrice: 270
  }
];
